export default "__VITE_ASSET__79a41308__"